import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom"
import styles from "./navbar.module.css";

function Navbar() {
    return (
        <nav id={styles.navigationBar}>
            <span id={styles.navItemLeft}>
                <a href='#main'>
                    <img
                        src={require("../static/logo/logoapricot.png")}
                        class={styles.navIcon}
                        alt="logo"
                    />
                </a>
                <a href='#main' className={styles.navLogo}>
                    nooriverse
                </a>
            </span>
            <span id={styles.navItem}>
                <a href='#main' className={styles.navLink}>
                    About
                </a>
                <a href='#skills' className={styles.navLink}>
                    Skills
                </a>
                <a href='#projects' className={styles.navLink}>
                    Projects
                </a>
                <a href='#artworks' className={styles.navLink}>
                    Artworks
                </a>
                <a href='#contacts' className={styles.navLink}>
                    Contacts
                </a>
            </span>
        </nav>
    );
}

export default Navbar;